<template>
  <div class="plan-selector">
    <form class="plan-selector__form" @submit.prevent="submit" novalidate>
      <div class="plan-selector__form__header">
        <h1 id="checkout-planos-título" v-html="$t('checkout.planSelector.title')"></h1>
        <p v-html="$t('checkout.planSelector.description')"></p>
      </div>
      <div class="plan-selector__form__body">
        <div v-if="!loading" class="plan-selector__form__body__plans" ref="plansScroll">
          <checkout-plan-box :key="i" @click="choose(plan)" :selected="selectedPlan" v-for="(plan, i) in plans" :plan="plan" />
        </div>
        <h2 v-if="loading">
          {{ $t('checkout.planSelector.loading') }}
        </h2>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  name: 'plan-selector',
  props: {
    loading: Boolean,
    plans: Array,
    selectedPlan: Object
  },
  methods: {
    choose(plan) {
      this.$emit('planChosen', plan)
    }
  },
  created() {
    let planToSelect = this.selectedPlan
    if (this.$route.query.sku) {
      const queryPlan = this.plans.find(it => it.sku === this.$route.query.sku)
      if (queryPlan) {
        planToSelect = queryPlan
      }
    }
    if (planToSelect) {
      this.$emit('planChosen', planToSelect)
    }
  }
}
</script>

<style lang="scss">
.plan-selector {
  position: relative;
  display: flex;
  flex-grow: 1;
  margin-top: 3rem;
  padding-top: 9.5rem;

  &__form {
    min-width: 100%;

    &__header {
      min-width: 100%;
      margin-bottom: 5rem;
      h1 {
        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 26px;
        line-height: 32px;
        color: #443D4B;
      }
      p {
        font-family: Nunito;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #454545;
      }
    }

    &__body {
      min-width: 100%;
      &__plans {

        flex-grow: 1;
        justify-content: space-evenly;
        flex-flow: wrap;
      }
      h2 {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 304px;
      }
      h2 {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 304px;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  .plan-selector {
    padding-top: 10rem;
    &__form {
      &__header {
        margin-bottom: 8rem;
        h1 {
          font-size: 34px;
          line-height: 34px;
        }
        p {
          font-size: 16px;
          line-height: 20px;
        }
      }
      &__body {
        &__plans {
          display: flex;
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .plan-selector {
    flex-direction: row;
    padding-top: 10rem;

    &__form {
      min-width: 800px;
      width: 100%;
      max-width: 1000px;
      &__header {
        h1 {
          font-size: 39.81px;
          line-height: 40px;
        }
        p {
          font-size: 19.2px;
          line-height: 24px;
        }
      }
    }
    &__icon {
      display: block;
      right: -2rem;
    }
  }
}
@media screen and (min-width: 1281px) {
  .plan-selector {
    flex-direction: row;

    &__form {
      margin-top: 4rem;
      &__header {
        margin-bottom: 8rem;
      }
      &__body {
        &__input-group {
          margin-bottom: 4rem;
        }
        &__button {
          margin-top: 5rem;
        }
      }
    }
    &__icon {
      top: -4.5rem;
      width: 476px;
      height: 976px;
    }
  }
}
</style>
